<template>
  <div id="topBar-holder" class="topBar-holder">
    <div class="topBar-container">
      <div class="topBar-left">
        <div id="btnSideBar" class="m-dev">
          <i class="fa-solid fa-bars m-dev fs20"></i>
        </div>
        <div class="btnLogo" @click="gotoRoute('/')">
          <img class="logo" src="/static/img/logo/logo.png" alt="logo" />
        </div>
      </div>
      <div class="topBar-right">
        <form class="top-login-form d-dev" novalidate="novalidate">
          <div class="topbar-buttons">
            <div class="menuItem">
              <div class="form-group form-special">
                <div class="input-holder">
                  <input autocomplete="off" name="username" type="text" class="username" placeholder="เบอร์โทรศัพท์"
                    maxlength="100" v-model="phoneNumber" />
                </div>

                <div class="text-grey pull-right mgt5">
                  <label class="control control-checkbox">
                    <input type="checkbox" class="remember_me" v-model="remember" :value="true" />
                    <div class="control_indicator"></div>
                    <span>จำฉัน</span>
                  </label>
                </div>
              </div>
              <div class="form-group form-special">
                <div class="input-holder">
                  <input autocomplete="off" name="password" :type="showPassRegister == false ? 'password' : 'text'"
                    class="password topBarPassword" placeholder="รหัสผ่าน" maxlength="100" v-model="password" />
                  <span class="input-icon" @click="showPassRegister = !showPassRegister">
                    <i class="fa fa-eye-slash vPassView" v-if="showPassRegister == false"></i>
                    <i class="fa fa-eye vPassView" v-if="showPassRegister == true"></i>
                  </span>
                </div>
                <div class="jErr"></div>
                <div class="pull-right mgt5" @click="goToLine()">
                  <div id="btnPopForgotPass" class="button-link">
                    ลืมรหัสผ่าน
                  </div>
                </div>
              </div>



              <div class="topbarButtons-holder ">
                <div @click="Login()" id="btnLoginTop" class="button button-login">
                  ลงชื่อเข้าใช้
                </div>


                <a id="btnRegister" class="button button-signup" href="javascript:void(0)"
                  @click="gotoRoute('/register')">ลงทะเบียน</a>
              </div>
            </div>
          </div>
        </form>
        <div class="m-dev">
          <div class="topbarButtons-holder">
            <div id="mbtnLoginTop" data-toggle="modal" data-target="#modalLogin" class="button button-login">
              ลงชื่อเข้าใช้
            </div>

            <a id="mbtnRegister" class="button button-signup" href="javascript:void(0)"
              @click="gotoRoute('/register')">ลงทะเบียน</a>
          </div>
        </div>
      </div>
    </div>
    <div class="topbar-menu" v-if="currentRouteName == 'Index'">
      <div class="topNavBarMenu d-dev">
        <div class="topNavBar-link">
          <ul class="dropdown-mainNav">
            <li>
              <a class="box d-dev active" data-type="home" data-v="home" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-home"></span>
              </a>
            </li>
            <li>
              <a class="box" data-type="live" data-v="game" data-name="คาสิโนสด" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-live"></span>
                <span>คาสิโนสด</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="slot" data-v="game" data-name="สล็อต" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-slot"></span>
                <span>สล็อต</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="card" data-v="game" data-name="การ์ด" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-card"></span>
                <span>การ์ด</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="sport" data-v="game" data-name="กีฬา" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-sport"></span>
                <span>กราฟ</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="topbar-menu-inner m-dev">
        <div class="d-game-type-list">
          <div class="game-type-list">
            <li>
              <a class="box d-dev active" data-type="home" data-v="home" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-home"></span>
              </a>
            </li>

            <li>
              <a class="box" data-type="live" data-v="game" data-name="คาสิโนสด" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-live"></span>
                <span>คาสิโนสด</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="slot" data-v="game" data-name="สล็อต" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-slot"></span>
                <span>สล็อต</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="card" data-v="game" data-name="การ์ด" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-card"></span>
                <span>การ์ด</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="sport" data-v="game" data-name="กีฬา" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-sport"></span>
                <span>กราฟ</span>
              </a>
            </li>
            <!-- <li>
              <a class="box" data-type="esport" data-v="game" data-name="อีสปอร์ต" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-esport"></span>
                <span>อีสปอร์ต</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="lottery" data-v="game" data-name="ล็อตเตอรี่" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-lottery"></span>
                <span>ล็อตเตอรี่</span>
              </a>
            </li>
            <li>
              <a class="box" data-type="cockfight" data-v="game" data-name="ไก่ชน" href="javascript:void(0)"
                @click="gotoRoute('/')">
                <span class="icon-cockfight"></span>
                <span>ไก่ชน</span>
              </a>
            </li> -->
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-menu m-dev" id="sidebar-menu">
      <div class="sidebar-header">
        <img class="logo" src="/static/img/logo/logo.png" alt="logo" />
        <div class="sidebar-close">
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>
      </div>
      <div class="sidebar-body">
        <div class="sidebar-list">
          <a class="box" href="javascript:void(0)" @click="gotoRoute('/')">
            <span class="icon icon-home"></span>
            <span>หน้าหลัก</span>
          </a>
          <a class="box" target="_blank" v-bind:href="`https://line.me/R/ti/p/${getLineId}`">
            <i class="fa-regular fa-user-headset"></i>
            <span>ติดต่อพวกเรา</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";

export default {
  name: "Header",
  data() {
    return {
      isShowNav: true,
      toggle: true,
      nowPage: this.$route.name,
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
      showPassRegister: false,
    };
  },
  watch: {},
  mixins: [UserInfoMixins],
  methods: {
    ...mapActions(["userSignOut", "appTitle", "userSignIn", "setError"]),
    gotoRouteGame(route) {
      this.$router.push({ path: route }).catch(() => { });
    },
    gotoRouteMobile(route) {
      var myCollapse = document.getElementById("navbarSupportedContent");
      console.log(myCollapse.classList.contains("show"));
      if (myCollapse.classList.contains("show")) {
        var bsCollapse = new bootstrap.Collapse(myCollapse);
        bsCollapse.hide();
      }
      this.$router.push(route).catch(() => { });
    },
    gotoRoute(route) {
      this.$router.push(route).catch(() => { });
    },
    getPageActive(page) {
      if (this.nowPage == page) {
        return "menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-9";
      }
    },
    async SignOut() {
      await this.userSignOut();
    },
    goToLine() {
      window.open(`https://line.me/R/ti/p/${this.getLineId}`, "_blank");
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
    ]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  mounted: function () {
    var test = false;
    $(document).ready(function () {


      $(document).on("click", ".sidebar-list .box", function (e) {

        $("#sidebar-menu").removeClass("active");
        $("html").removeClass("insidemenu");

      });

      $(document).on("click", "#btnSideBar, .sidebar-close", function (e) {
        if (window.matchMedia("(max-width: 800px)").matches) {
          if (!test) {
            test = true;
            $("#sidebar-menu").addClass("active");
            $("html").addClass("insidemenu");
          } else {
            test = false;
            $("#sidebar-menu").removeClass("active");
            $("html").removeClass("insidemenu");
          }
        } else {
          location.href = "/";
        }
      });

      $(document).on("click", ".btnLogo", function (e) {
        location.href = "/";
      });
    });
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue